import styled from '../../../utils/styling/styled';

export const Item = styled.div`
  flex-shrink: 0;
  scroll-snap-align: start;
`;
